import type { Drone, LifecycleLog, SettableLifecycleStatus } from '../../types';

// Applies a manual claim/release override on top of a drone's lifecycle status.
// The effective status is the override when present, otherwise the drone's own
// lifecycleStatus. A matching override carries a fresh log; when no override
// exists the drone keeps any pre-seeded lifecycleLog from mock data.
export const applyLifecycle = ({
    drone,
    lifecycleLogs,
    lifecycleOverrides
}: {
    drone: Drone;
    lifecycleLogs: Record<string, LifecycleLog>;
    lifecycleOverrides: Record<string, SettableLifecycleStatus>;
}): Drone => {
    const override = lifecycleOverrides[drone.id];

    if (!override) {
        return drone;
    }

    return {
        ...drone,
        lifecycleLog: lifecycleLogs[drone.id] ?? drone.lifecycleLog,
        lifecycleStatus: override
    };
};
